import { Box, IconButton as MuiIconButton} from "@mui/material";
import React, { useEffect, useState }  from "react";
import { Line,Cancel, checkedIcon, closePopup } from "../../style/images";
import classNames from "classnames";

export const SymbolTextModal=({data,cancelText,actionText,onClick,onClose,selectedValueFromSelection})=>{
         const [value, setValue]=useState({});
        const selectValue=(icon)=>{
            setValue(icon)
        }
        useEffect(()=>{
            setValue(selectedValueFromSelection)
        },[selectedValueFromSelection])
        const text='Select text or symbol'
        const classNameApply=classNames('primary-button',{'disabled': !(value && value.name)})
        const classNameApplyText=classNames('symbol-text-modal-footer-primary-button-icon-button',{'disabled':!(value && value.name)})
            return (        
                <div  className="symbol-text-modal">
                    <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={(e)=>{onClose()}} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
                        <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
                    </MuiIconButton>
                   <div className="symbol-text-modal-content">
                       <div className="symbol-text-modal-content-header">
                       <div>
                       {/* <Box component='img' className="symbol-text-modal-cancel" src={Cancel} onClick={(e)=>{onClose()}}></Box> */}
                       <Box component='img' className="symbol-text-modal-content-header-line" src={Line} ></Box>
                       </div>
                       <div className="symbol-text-modal-content-header-text">{text}</div>
                       </div>
                       <div className="symbol-text-modal-content-images">
                           {data.map(icon=>{
                               return value && value.name==icon.name? <div className={classNames("symbol-text-modal-content-image",{"selected":value && value.name===icon.name})} style={{border:"5px solid var(--Primary-Color-Grey-30, #BABABA)"}} onClick={(e)=>{selectValue(icon)}}>
                               <Box component='img' className="symbol-text-modal-content-image-icon-selected" src={`../publicNewUI/${icon.name}.svg`}  alt={icon.name} onClick={(e=>{selectValue(icon)})} >
                               </Box>
                               <Box component='img' className='symbol-icon-selector-icon-checked' src={checkedIcon} onClick={(e)=>{selectValue(icon)}}></Box>
                             </div>:
                               <div className="symbol-text-modal-content-image" onClick={(e)=>{selectValue(icon)}}>
                               <Box component='img' className="symbol-text-modal-content-image-icon" src={`../publicNewUI/${icon.name}.svg`}  alt={icon.name} onClick={(e=>{selectValue(icon)})} >
                               </Box>
                               </div>
                           })}
                       </div>           
                   </div>
                   <div className="symbol-text-modal-footer">
                       <div className="symbol-text-modal-footer-frame" onClick={(e)=>{onClose()}}>
                           <div className="tertiary-button">
                               <div className="symbol-text-modal-footer-link-button-icon"></div>
                               <span>{cancelText}</span>
                               <div className="symbol-text-modal-footer-link-button-icon"></div>
                               
                           </div>
                           <div className={classNameApply} onClick={(e=>{onClick(value);onClose()})}>
                               <div className="symbol-text-modal-footer-primary-button-icon"></div>
                               <span>{actionText}</span>
                               <div className="symbol-text-modal-footer-primary-button-icon">
                           </div>       
                           </div>
                       </div>
                   </div>
               </div>
           )
        
    }
